import { useRef } from "react";

function offsetInContainer(container, node, offset) {
  const range = document.createRange();
  range.selectNodeContents(container);
  range.setEnd(node, offset);
  return range.toString().length;
}

// Renders plain text with highlighted annotation ranges. In non-readOnly mode,
// selecting text calls onSelectRange({start, end, quote}) with plain-text offsets.
export function AnnotatedText({ text = "", annotations = [], activeId, onSelectRange, onClickAnnotation, readOnly }) {
  const ref = useRef(null);

  const handleMouseUp = () => {
    if (readOnly || !onSelectRange) return;
    const sel = window.getSelection();
    if (!sel || sel.isCollapsed || sel.rangeCount === 0) return;
    const range = sel.getRangeAt(0);
    const container = ref.current;
    if (!container || !container.contains(range.startContainer) || !container.contains(range.endContainer)) return;
    let start = offsetInContainer(container, range.startContainer, range.startOffset);
    let end = offsetInContainer(container, range.endContainer, range.endOffset);
    if (start > end) [start, end] = [end, start];
    if (end - start < 1) return;
    onSelectRange({ start, end, quote: text.slice(start, end) });
    sel.removeAllRanges();
  };

  const valid = [...annotations].filter((a) => a.end > a.start).sort((a, b) => a.start - b.start);
  const segments = [];
  let cursor = 0;
  valid.forEach((a) => {
    const s = Math.max(a.start, cursor);
    if (s > cursor) segments.push({ text: text.slice(cursor, s) });
    if (a.end > s) { segments.push({ text: text.slice(s, a.end), ann: a }); cursor = a.end; }
  });
  if (cursor < text.length) segments.push({ text: text.slice(cursor) });
  if (segments.length === 0) segments.push({ text });

  return (
    <div ref={ref} onMouseUp={handleMouseUp} data-testid="annotated-text"
      className={`max-h-[460px] overflow-y-auto whitespace-pre-wrap rounded-xl border border-[#EEEAF8] p-4 text-[15px] leading-relaxed text-[#1E1B2E] ${readOnly ? "" : "cursor-text select-text"}`}>
      {segments.map((seg, i) => seg.ann ? (
        <mark key={i} data-testid={`hl-${seg.ann.id}`} onClick={() => onClickAnnotation && onClickAnnotation(seg.ann.id)}
          title={seg.ann.comment}
          className={`cursor-pointer rounded border-b-2 border-[#F59E0B] px-0.5 transition-colors ${activeId === seg.ann.id ? "bg-[#FDE68A]" : "bg-[#FEF3C7]"}`}>
          {seg.text}
        </mark>
      ) : <span key={i}>{seg.text}</span>)}
    </div>
  );
}
